<template>
  <div>
    <el-form ref="formRef" :model="tipForm" label-width="88px">
      <el-form-item label="提示标题：">
        <el-input v-model="tipForm.title" placeholder="30字以内" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="链接地址：">
        <el-input v-model="tipForm.url" placeholder="请输入合法的链接地址" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="tipForm.orderNum" placeholder="请输入整数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="标注重要：">
        <el-radio-group v-model="tag">
          <el-radio-button :label="0">不标注重要</el-radio-button>
          <el-radio-button :label="1">标注重要</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="跳转类型：">
        <el-select v-model="urlType" placeholder="请选择">
          <el-option
              v-for="item in urlTypeArray"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateOrAddSysWarmTip } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      tipForm: this.value.tipForm,
      idx: this.value.ids,
      loading: false,

      urlTypeArray: [
        {label : '内置浏览器', value : 1},
        {label : '外部浏览器', value : 2}
      ],
      urlType: this.value.tipForm.urlType?this.value.tipForm.urlType:1,
      tag: this.value.tipForm.tag?this.value.tipForm.tag:0
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.tipForm.title) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '提示标题不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.tipForm.url) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '链接地址不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.tipForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.tipForm.id?this.tipForm.id:0;
      param['title'] = this.tipForm.title;
      param['url'] = this.tipForm.url;
      param['orderNum'] = this.tipForm.orderNum;
      param['tag'] = this.tag;
      param['urlType'] = this.urlType;
      postFormData(updateOrAddSysWarmTip, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
